import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';

// Register service worker for PWA functionality.
// public/service-worker.js is the only worker (network-first, skipWaiting +
// clients.claim), so a new deploy takes over on the next load. Open sessions
// are told via a window event so the user can refresh when convenient.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Only a takeover of an already-controlled page is an "update" — on first
    // install there is no controller yet.
    // Only a new version of *this* worker script counts as an update. The
    // controller briefly switching to/from a legacy worker (the old Workbox
    // sw.js) or to none is not a deploy and must not raise the banner.
    const scriptOf = (c) => (c && c.scriptURL ? new URL(c.scriptURL).pathname : null);
    let lastScript = scriptOf(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      const current = scriptOf(navigator.serviceWorker.controller);
      if (lastScript === '/service-worker.js' && current === '/service-worker.js') {
        window.dispatchEvent(new Event('sw-update-available'));
      }
      lastScript = current;
    });

    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        // Long-lived installed PWAs rarely reload — check when the app returns
        // to the foreground and hourly.
        const check = () => registration.update().catch(() => {});
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') check();
        });
        setInterval(check, 60 * 60 * 1000);
      })
      .catch(() => {});
  });
}

// A lazy chunk that 404s (the app shell predates a deploy) would leave a blank
// page. Reload once to pick up the current index.html; the flag prevents loops.
window.addEventListener('vite:preloadError', () => {
  try {
    if (sessionStorage.getItem('chunk-reload')) return;
    sessionStorage.setItem('chunk-reload', '1');
  } catch { /* storage blocked — still reload once per page load */ }
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
